import { render, staticRenderFns } from "./TabItineraryReorderItem.vue?vue&type=template&id=63c26b9a&scoped=true&"
import script from "./TabItineraryReorderItem.vue?vue&type=script&lang=js&"
export * from "./TabItineraryReorderItem.vue?vue&type=script&lang=js&"
import style0 from "./TabItineraryReorderItem.vue?vue&type=style&index=0&id=63c26b9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c26b9a",
  null
  
)

export default component.exports